export const queryAccounts = (resolve, reject, tokenId, reqBodyObj) => {
  let req = new Request(window.CONFIG.AWS_URL + '/queryaccounts', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('queryAccounts response format error.');
      }
    } else {
      reject('queryAccounts response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const deleteAccount = (resolve, reject, tokenId, reqBodyObj) => {
  let req = new Request(window.CONFIG.AWS_URL + '/delaccount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('deleteAccount response format error.');
      }
    } else {
      reject('deleteAccount response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}